import { network } from 'services/network';

export const setViewSettings = (params: QueryParams) => {
    return network.post('api/bo/setViewSettings', params).then((response) => response.data);
};

export interface QueryParams {
    viewId: number;
    viewControls: {
        showBaseline: boolean;
        showlabels: boolean;
        colorBy: string;
    };
}
